import { useEffect, useState } from "react"
import i18n from "../../i18n/i18n"
import LogoMobileES from '../../assets/images/logos/logo-es.png'
import LogoMobilePT from '../../assets/images/logos/logo-pt.png'
import LogoMobileEN from '../../assets/images/logos/logo-en.png'



export const Logo = () => {
    const [isMobile, setIsMobile] = useState(
        window.matchMedia('(max-width: 768px)').matches
    )
    useEffect(() => {
        const mediaQuery = window.matchMedia('(max-width: 768px)')
        const handleChange = (e: any) => setIsMobile(e.matches)

        mediaQuery.addEventListener('change', handleChange)
        return () => mediaQuery.removeEventListener('change', handleChange)
    }, [])

    const findLogo = () => {
        return i18n.language.includes('es')
            ? LogoMobileES
            : i18n.language.includes('pt')
                ? LogoMobilePT
                : i18n.language.includes('en')
                    ? LogoMobileEN
                    : LogoMobileES
    }


    return (
        <img
            style={!isMobile ? { maxWidth: 250, height: 'auto' } : {}}
            src={findLogo()}
            alt="Litio en Conflicto"
        />
    )
}